import NewMessage from './NewMessage';

export default NewMessage;



// WEBPACK FOOTER //
// ./app/javascript/common/components/NewMessage/index.js